import StateObserver, { now } from 'src/StateObserver';
import {
  getActiveRace,
  getRaceStartTime,
  getRacePosition,
} from 'src/replicant/match2/races/races.getters';

export function getRaceAnalytics() {
  const { user } = StateObserver.getState();
  const { pendingRaceScore, races } = user.match2;

  const id = pendingRaceScore?.raceId ?? '';
  const index = (races[id]?.length ?? 1) - 1;
  const race = races[id]?.[index];

  if (!race) return {};

  const raceConfig = pendingRaceScore?.raceId
    ? getActiveRace(getRaceStartTime(pendingRaceScore?.raceId))?.config
    : undefined;

  return {
    properties: {
      raceScoreAdded: pendingRaceScore?.score,
      raceEventID: pendingRaceScore?.raceId
        ? `${pendingRaceScore?.raceId}-${raceConfig?.theme}`
        : undefined,
      raceScoreTotal: (race?.score ?? 0) + (pendingRaceScore?.score ?? 0),
      raceType: raceConfig?.type,
    },
    getPosition: () => {
      return getRacePosition(StateObserver.getState().user, id, index, now());
    },
  };
}
